export default __webpack_public_path__ + "static/media/watchTwo.e47ba80b.jpg";